<template>
  <div class="shopping-cart-300 col-lg-6 col-md-8 col-11  mx-auto fixed-bottom"
       :class="[shoppingCartCount>0?'shopping-cart-300-in':'shopping-cart-300-out']">
    <div class="row align-items-center p-2">
      <div class="col-8 text-right pr-0">
        <m-a :href="shoppingCartLink">
          <div class="btn btn-secondary">
            <span v-t="`shopping_cart.mini_shopping_cart.submit_button`"></span>
            <img class="shopping-cart-300-image mr-2" :src="shopIcon" :alt="findAttributeOnSiteInfo('site_name')[0]"/>
          </div>
        </m-a>
      </div>
      <div class="col-4 text-left">
        <div class="p-0 m-0">
          <span v-html="$t('price.price',{currency:formatNumber(totalPrice)})"></span>
          <span class="d-block mt-1">
            <span v-t="`shopping_cart.mini_shopping_cart.quantity`"></span>
            {{ formatNumber(shoppingCartCount) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {
  productPriceOnUnAuthShoppingCard,
  subProducts
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {findHashProductOnLocalStorage} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";
import store from "@/store";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import mA from '../Tags/A.vue'
import {setSeoOnWrapper} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";


function watchAnyObject(
    object = {},
    methods = [],
    callbackBefore = function () {
    },
    callbackAfter = function () {
    },
) {
  for (let method of methods) {
    const original = object[method].bind(object);
    const newMethod = function (...args) {
      callbackBefore(method, ...args);
      const result = original.apply(null, args);
      callbackAfter(method, ...args);
      return result;
    };
    object[method] = newMethod.bind(object);
  }
}

export default {
  name: "ShoppingCart300",
  components: {mA},
  props: {
    shopIcon: {
      default: 'data:image/png;base64,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\n'
    }
  },
  data() {
    return {
      productList: [],
      totalPrice: 0,
      shoppingCartCount: 0,
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'User/isAuthenticated',
      authenticatedShoppingCart: 'ShoppingCart/getUserOrderUnpaidItems'
    }),
    shoppingCartLink() {
      if (this.isAuthenticated) {
        return {name: "ShoppingCart"}
      }
      return {name: 'UnAuthenticatedShoppingCart'}
    }
  },
  methods: {
    findAttributeOnSiteInfo,
    formatNumber,
    async getProductOnUnAuthenticated() {
      let productsLink = [];
      let productsJson = JSON.parse(localStorage.getItem('products'))
      if (productsJson !== null) {
        Object.keys(productsJson).forEach(function (key) {
          if (productsLink.indexOf(productsJson[key]['product']) == -1) {
            productsLink.push(productsJson[key]['product'])
          }
        })
        let result = await this.$store.dispatch("ShoppingCart/getProductListWithoutState", productsLink)
        return result
      }
    },
    async setProductList() {
      if (this.isAuthenticated) {
        this.productList = this.authenticatedShoppingCart
        return true
      }


      let result = await this.getProductOnUnAuthenticated()
      this.productList = result
      return true
    },
    totalPriceMethod() {
      this.totalPrice = 0
      if (this.isAuthenticated) {
        let order = this.$store.getters['ShoppingCart/getSidebarBasketData']
        this.totalPrice = parseInt(order.paying_amount) - parseInt(order.delivery_amount)
        return true
      }

      this.setUnAuthenticatedProductListSummary()

      return false
    },
    setUnAuthenticatedProductListSummary() {


      this.productList.forEach(product => {
        subProducts(product).forEach(sub_product => {
          let item_in_storage = findHashProductOnLocalStorage(sub_product);
          if (item_in_storage !== undefined) {
            // convert local storage object to json to find item on it with index and extract quantity
            const offer = productPriceOnUnAuthShoppingCard(sub_product, product)['offer'] === null ? 0 : productPriceOnUnAuthShoppingCard(sub_product, product)['offer']
            let productQuantity = JSON.parse(localStorage.getItem('products'))[item_in_storage]['quantity'];
            let sumPriceWithoutOffer = parseInt(productPriceOnUnAuthShoppingCard(sub_product, product)['price']) * productQuantity
            let sumOffer = parseInt(offer) * productQuantity
            this.totalPrice += (sumPriceWithoutOffer - sumOffer)
          }
        })
      })


      return true
    },
    async getUnAuthBasketItems() {
      if (localStorage.getItem('products') !== null) {

        let productsJson = JSON.parse(localStorage.getItem('products'))
        let form = new FormData();
        let counter = 0;

        Object.keys(productsJson).forEach(function (key) {
          form.append(`product[${counter}][id]`, productsJson[key]['id'])
          if (productsJson[key]['sub_product_id'] > 0) {
            form.append(`product[${counter}][sub_product]`, productsJson[key]['sub_product_id'])
          }
          counter += 1;
        })

        let user_id = this.$store.getters['User/getUserId']
        store.dispatch("ShoppingCart/addItemWithoutState", {user_id, form}).then(res => {
          const shoppingCart = res.data.data;
          const order_id = shoppingCart.id;
          const items = shoppingCart.items;


          // find local storage item in shopping cart items
          items.forEach(item => {
            Object.keys(productsJson).forEach(function (key) {
              let product = productsJson[key];
              if (product['sub_product_id'] == item.sub_product && product['id'] == item.product.id) {

                let form = {
                  order_id: order_id,
                  order_product_id: item.id,
                  quantity: product['quantity'],
                  user_id: user_id,
                }

                store.dispatch("ShoppingCart/changeQuantityWithoutState", form)

              }
            })
          })


        })

        this.$store.dispatch('ShoppingCart/userOrderUnpaid')
        localStorage.removeItem('products')

      }
    },
    countProducts() {
      if (this.isAuthenticated) {
        let quantities = 0

        this.authenticatedShoppingCart.forEach(item => {
          quantities += item.quantity
        })

        this.shoppingCartCount = quantities
        return true
      }
      let productsJson = JSON.parse(localStorage.getItem('products'))
      if (productsJson !== null) {


        let totalQuantity = 0
        Object.entries(productsJson).forEach((item) => {
          item = item[1]
          totalQuantity += item['quantity']
        })

        this.shoppingCartCount = totalQuantity
      } else {
        this.shoppingCartCount = 0
      }

      return true
    },

  },
  async mounted() {
    if (this.isAuthenticated) {
      await this.getUnAuthBasketItems()
      this.countProducts()
    } else {
      await this.setProductList()
      this.countProducts()

      watchAnyObject(
          window.localStorage,
          ['setItem'],
          () => {
          },
          async () => {
            await this.setProductList()
            this.countProducts()
            this.totalPriceMethod()
          },
      );


    }
    setSeoOnWrapper({},'shopping-cart')

  },
  watch: {
    shoppingCartCount: {
      handler(newValue, oldValue) {
        this.totalPriceMethod()
      },
    },
    authenticatedShoppingCart: {
      handler() {
        this.countProducts()
      },
      deep: true
    },
  }
}
</script>

<style scoped>
.shopping-cart-300 * {
  font-size: 11px;
}

.shopping-cart-300 {
  background: var(--primary);
  bottom: 10px;
  border-radius: 10px;
}

.shopping-cart-300-image {
  width: 30px;
  height: 30px;
}

@keyframes rollIn {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}


@keyframes rollout {
  0% {
    opacity: 1;
    transform: translateY(0);
  }

  99% {
    opacity: .25;
    transform: translateY(50px);
  }

  100% {
    opacity: 0;
    display: none;
  }
}

.shopping-cart-300-in {
  animation: rollIn .5s ease-in-out 0s 1 normal none;
}

.shopping-cart-300-out {
  animation: rollout .5s 1 linear forwards;
}

</style>
